import { useState, useEffect, useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Col from "react-bootstrap/Col";
import "./Navigation.css";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import NavDropdown from "react-bootstrap/NavDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import Badge from "react-bootstrap/Badge";
import LogoutModal from "./LogoutModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faVideo,
  faCog,
  faSearch,
  faBell,
  faSignInAlt,
  faHistory,
  faHome,
  faUserCog,
  faBars,
  faBookmark,
  faKey,
  faChartLine,
  faLayerGroup,
  faCampground,
  faBox,
  faBoxOpen,
  faBroadcastTower,
} from "@fortawesome/free-solid-svg-icons";
import Alert from "react-bootstrap/Alert";
import Cookies from "js-cookie";
import NavItem from "../Sidebar/NavItem";
import { MessagesContext } from "../../context/messages";
import { ProfileContext } from "../../context/profile";
import { useToaster } from "../../context/toaster";
import { messagesFetcher } from "../../api/requests";
import { SearchContext } from "../../context/search";
import { AuthContext } from "../../context/auth";
import { SidebarContext } from "../../context/sidebar";
import AlertModal from "./alertModal";
import { baseURL } from "../../api/dataFetcher";

const Navigation = () => {
  const [show, setShow] = useState(false);
  const [loginStatus, setLoginStatus] = useState("");
  const [user, setUser] = useState();
  const { messages, unreadMessages } = useContext(MessagesContext);
  const { profile, updateProfile } = useContext(ProfileContext);
  const { logout, user: authUser, isLoggedIn } = useContext(AuthContext);
  const { toggleSidebar } = useContext(SidebarContext);
  const [parsedUser, setParsedUser] = useState();
  const { addMessage } = useToaster();
  const logo = process.env.PUBLIC_URL + "/img/vaghfnama-logo.png";
  const [search, setSearch] = useState("");
  const history = useHistory();
  const { updateSearchedItem, setSearchType, searchType } =
    useContext(SearchContext);
  const [showAlert, setShowAlert] = useState(false);
  const location = useLocation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleAlertShow = () => setShowAlert(true);
  const handleAlertClose = () => setShowAlert(false);

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    updateProfile({});
    setUser("");
    Cookies.remove("vaghfnamaUser");
    handleClose();
    showToast("success", "با موفقیت خارج شدید.");
    setLoginStatus("ورود");
    history.push("/");
  };

  const handleMenuToggle = () => {
    toggleSidebar();
  };

  const handleLogging = () => {
    loginStatus === "خروج" ? handleShow() : history.push("/auth/login");
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  useEffect(() => {
    const user = Cookies.get("vaghfnamaUser");
    if (user) {
      setUser(user);
      const parsed = JSON.parse(user);
      setParsedUser(parsed);
      setLoginStatus("خروج");
    } else {
      setUser(null);
      setParsedUser(null);
      setLoginStatus("ورود");
    }
  }, [isLoggedIn, authUser]);

  const handleReadClick = async () => {
    try {
      const res = await messagesFetcher.post();

      window.location.reload();
    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  };

  const handleSearchChange = (e) => {
    const next = e.target.value;
    setSearch(next);

    // Live-search only on channels page
    const currentPath = (location && location.pathname) || "";
    if (currentPath.startsWith("/channels")) {
      const params = new URLSearchParams(location.search);
      if ((next || "").trim()) {
        params.set("search", next);
      } else {
        params.delete("search");
      }
      const searchStr = params.toString();
      history.replace({
        pathname: currentPath,
        search: searchStr ? `?${searchStr}` : "",
      });
    }
  };

  const handleSearchClick = async () => {
    const currentPath = (location && location.pathname) || "";
    const isChannelsContext =
      currentPath.startsWith("/channels") ||
      currentPath.startsWith("/campaigns");

    if (isChannelsContext || (searchType || "").trim() === "کانال") {
      history.push(`/channels?search=${encodeURIComponent(search)}`);
    } else {
      history.push("/search");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchClick();
    }
  };

  useEffect(() => {
    updateSearchedItem(search);
  }, [search]);

  // Navigate based on explicit user selection of search type
  const handleSelectSearchType = (type) => {
    setSearchType(type);
    const currentPath = (location && location.pathname) || "";

    // Do not auto-navigate when on the homepage
    if (currentPath === "/") return;

    if ((type || "").trim() === "کانال") {
      if (!currentPath.startsWith("/channels")) {
        const params = new URLSearchParams(location.search);
        if ((search || "").trim()) {
          params.set("search", search);
        } else {
          params.delete("search");
        }
        const searchStr = params.toString();
        history.push({
          pathname: "/channels",
          search: searchStr ? `?${searchStr}` : "",
        });
      }
    } else {
      if (!currentPath.startsWith("/search")) {
        history.push("/search");
      }
    }
  };

  const alerts =
    unreadMessages?.results?.length > 0 &&
    unreadMessages?.results?.map((item, idx) => (
      <div key={idx}>
        {item.is_read === false && (
          <Link to="/blank" key={idx}>
            <Alert
              variant={"success"}
              style={{ padding: "2%", fontSize: "12px" }}
            >
              {item.message}
            </Alert>
          </Link>
        )}
      </div>
    ));

  return (
    <>
      <Navbar
        bg="white"
        sticky="top"
        className="osahan-nav"
        style={{
          justifyContent: "center",
          paddingLeft: "30px",
          paddingRight: "30px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Button
            variant="link"
            size="sm"
            className="order-0 text-secondary"
            id="sidebarToggle"
            onClick={handleMenuToggle}
          >
            <FontAwesomeIcon icon={faBars} />
            <i className="fas fa-star"></i>
          </Button>
          <Navbar.Brand className="mr-1">
            <a
              href="/"
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                color: "#dfb46a",
              }}
            >
              <img
                style={{ width: "100%", height: "55px" }}
                className="img-fluid logo"
                src={logo}
                alt=""
              />
            </a>
          </Navbar.Brand>

          {/* Navbar Search*/}
          <Form
            inline
            className="d-none d-md-inline ml-auto my-2 my-md-0 osahan-navbar-search"
          >
            <InputGroup>
              <InputGroup.Append>
                <Button
                  onClick={handleSearchClick}
                  variant="light"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
              </InputGroup.Append>

              <FormControl
                onChange={handleSearchChange}
                onKeyPress={handleKeyPress}
                type="text"
                placeholder="جستجو..."
                className="inputRtlByMe"
                style={{ borderLeft: "none" }}
              />

              <NavDropdown
                align="end"
                title={`جستجو در ${searchType || "ویدئو"} `}
                id="search-type-dropdown"
                className="no-arrow searchType"
                style={{
                  padding: "0 10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <span
                    style={{ fontSize: "12px", cursor: "pointer" }}
                    onClick={() => handleSelectSearchType("ویدئو")}
                  >
                    ویدئو
                  </span>
                  <span
                    style={{ fontSize: "12px", cursor: "pointer" }}
                    onClick={() => handleSelectSearchType("کانال")}
                  >
                    کانال
                  </span>
                </Col>
              </NavDropdown>
            </InputGroup>
          </Form>

          {/*Navbar*/}
          <ul className="navbar-nav ml-md-0 osahan-right-navbar messageList">
            {user && (
              <NavDropdown
                style={{ height: "50%" }}
                title={
                  <>
                    <FontAwesomeIcon icon={faBell} fixedWidth />
                    {unreadMessages?.results?.length > 0 && (
                      <Badge variant="danger">
                        {unreadMessages?.total_objects}
                      </Badge>
                    )}
                  </>
                }
                id=""
                className="mx-1 no-arrow"
              >
                <Col md={12}>
                  {unreadMessages?.results?.length > 0 ? (
                    <>
                      <span
                        style={{ fontSize: "10px", cursor: "pointer" }}
                        onClick={handleReadClick}
                      >
                        خواندن همه
                      </span>
                      {alerts}{" "}
                    </>
                  ) : (
                    <>
                      <p style={{ padding: "2%", fontSize: "12px" }}>
                        شما پیام جدیدی ندارید.
                      </p>
                      <Link
                        to="/blank"
                        style={{ padding: "2%", fontSize: "10px" }}
                      >
                        نمایش پیام های قبلی
                      </Link>
                    </>
                  )}
                </Col>
              </NavDropdown>
            )}
            <NavItem href="/" className="home" faIcon={faHome} active />
            <NavDropdown
              title={
                <>
                  <img
                    src={
                      profile?.image && user
                        ? baseURL + profile?.image
                        : "/img/user.svg"
                    }
                    alt="Avatar"
                  />
                  <span
                    className="d-none d-md-inline mr-1"
                    style={{ cursor: "pointer" }}
                  >
                    {user ? profile?.first_name : "ورود"}
                  </span>
                </>
              }
              id=""
              className="no-arrow osahan-right-navbar-user user-dropdown-link"
            >
              {user && (
                <>
                  {parsedUser?.role !== "nobody" ? (
                    <Link to="/account" className="dropdown-item" role="button">
                      <FontAwesomeIcon icon={faUserCircle} fixedWidth /> حساب
                      کاربری من
                    </Link>
                  ) : (
                    <>
                      <span
                        onClick={handleAlertShow}
                        className="dropdown-item pointer"
                        role="button"
                      >
                        <FontAwesomeIcon icon={faUserCircle} fixedWidth />
                        درخواست ارتقاء حساب کاربری
                      </span>
                      <AlertModal
                        show={showAlert}
                        handleClose={handleAlertClose}
                      />
                    </>
                  )}
                  <Link
                    to="/subscriptions"
                    className="dropdown-item"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faVideo} fixedWidth /> کانال های
                    دنبال شده
                  </Link>
                  <Link
                    to="/savedVideos"
                    className="dropdown-item"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faBookmark} fixedWidth /> ویدئوهای
                    ذخیره شده
                  </Link>
                  <Link
                    to={`/campaign-videos/?campaign=true&admin=false&publisher=${profile?.id}`}
                    className="dropdown-item"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faBoxOpen} fixedWidth /> ویدئوهای
                    ارسال شده در پویش
                  </Link>
                  <Link to="/blank" className="dropdown-item" role="button">
                    <FontAwesomeIcon icon={faBell} fixedWidth /> پیام ها
                  </Link>
                  <Link to="/history" className="dropdown-item" role="button">
                    <FontAwesomeIcon icon={faHistory} fixedWidth /> تاریخچه
                  </Link>
                  <Link
                    to="/changePassword"
                    className="dropdown-item"
                    role="button"
                  >
                    <FontAwesomeIcon icon={faKey} fixedWidth /> تغییر رمز عبور
                  </Link>
                  <Link to="/settings" className="dropdown-item" role="button">
                    <FontAwesomeIcon icon={faCog} fixedWidth /> تنظیمات
                  </Link>
                  {(parsedUser.role === "is_superuser" ||
                    parsedUser.role === "is_supervisor") && (
                    <Link
                      to="/statistics"
                      className="dropdown-item"
                      role="button"
                    >
                      <FontAwesomeIcon icon={faChartLine} fixedWidth /> گزارش
                      گیری کانال ها
                    </Link>
                  )}
                  {(parsedUser.role === "is_superuser" ||
                    parsedUser.role === "is_supervisor") && (
                    <Link
                      to="/statistics/?campaign=true"
                      className="dropdown-item"
                      role="button"
                    >
                      <FontAwesomeIcon icon={faChartLine} fixedWidth /> گزارش
                      گیری پویش ها
                    </Link>
                  )}
                  {(parsedUser.role === "is_superuser" ||
                    parsedUser.role === "is_supervisor") &&
                    parsedUser.permissions.includes("user_list") && (
                      <Link
                        to="/user-management"
                        className="dropdown-item"
                        role="button"
                      >
                        <FontAwesomeIcon icon={faUserCog} fixedWidth /> مدیریت
                        کاربران
                      </Link>
                    )}
                  {(parsedUser.role === "is_superuser" ||
                    parsedUser.role === "is_supervisor") &&
                    parsedUser.permissions.includes("box_managment") && (
                      <Link
                        to="/box-management"
                        className="dropdown-item"
                        role="button"
                      >
                        <FontAwesomeIcon icon={faLayerGroup} fixedWidth />{" "}
                        مدیریت باکس ها
                      </Link>
                    )}
                  {(parsedUser.role === "is_superuser" ||
                    parsedUser.role === "is_supervisor") &&
                    parsedUser.permissions.includes("public_notification") && (
                      <Link
                        to="/broadcast"
                        className="dropdown-item"
                        role="button"
                      >
                        <FontAwesomeIcon icon={faBroadcastTower} fixedWidth />{" "}
                        ارسال پیام همگانی
                      </Link>
                    )}
                  <Dropdown.Divider />
                </>
              )}
              <span
                onClick={handleLogging}
                className="dropdown-item"
                role="button"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3px",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={faSignInAlt} fixedWidth /> {loginStatus}
              </span>
            </NavDropdown>
          </ul>
        </div>
      </Navbar>

      <LogoutModal
        show={show}
        handleClose={handleClose}
        handleLogout={handleLogout}
      />
    </>
  );
};

export default Navigation;
